import axios from 'axios';
import { getCurrentBeLang } from '../contexts/LanguageContext';

const client = axios.create({
  baseURL: process.env.REACT_APP_API_URL ?? 'http://localhost:8000',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor — Bearer Token + 다국어 lang 자동 첨부
// (API_DOCS 공통: Authorization: Bearer {access_token})
client.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('accessToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // 모든 요청에 lang 파라미터 자동 추가 (관리자 endpoint 제외)
    // BE는 ko/en/zh/ja/es 코드 사용, 명시적으로 지정된 경우는 그대로 둠
    const url = config.url || '';
    const isAdmin = url.startsWith('/api/admin');
    if (!isAdmin) {
      const beLang = getCurrentBeLang();
      config.params = config.params || {};
      if (config.params.lang === undefined && config.params.language === undefined) {
        config.params.lang = beLang;
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor — 에러 처리
// API_DOCS 공통 에러 응답: { "detail": "에러 메시지" }
client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('accessToken');
      // 관리자 페이지면 관리자 로그인으로
      const isAdmin = window.location.pathname.startsWith('/admin');
      window.location.href = isAdmin ? '/admin/login' : '/login';
    }

    // 에러 메시지 정규화: API_DOCS 기준 { detail: string | array }
    const detail = error.response?.data?.detail;
    if (detail) {
      if (typeof detail === 'string') {
        error.message = detail;
      } else if (Array.isArray(detail)) {
        error.message = detail.map((d) => d.msg || JSON.stringify(d)).join(', ');
      }
    }

    // X-Error-Code 헤더 → err.code (FE에서 i18n 매핑용)
    // BE가 한국어 detail 을 그대로 보내도 헤더만 있으면 FE 가 번역 가능.
    const codeHeader = error.response?.headers?.['x-error-code'];
    if (codeHeader) {
      error.code = codeHeader;
    }

    return Promise.reject(error);
  }
);

export default client;
